import React from "react";

const Header = () => {
    return (
        <header className="bg-white shadow-md p-4">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold text-green-600">PEAKBOT</h1>
                <nav>
                    <ul className="flex space-x-4">
                        <li>
                            <a href="#">    
                            <img
                            src="/qfaa-logo.png"
                            alt="JTNCBOT Logo"
                            className="h-10 sm:h-12 md:h-14 lg:h-15 w-auto object-contain drop-shadow-md"
                            />
                            </a>
                        </li>
                        <li><a href="#">Algos</a></li>
                        <li><a href="#">Watchlist</a></li>
                        <li><a href="#">Upgrade</a></li>
                        <li><a href="#">Learn</a></li>
                        <li><a href="#">Account</a></li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
